import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function leaderReducer(state = initialState.leaders, action) {
  switch (action.type) {
    case types.LOAD_LEADER_DATA_SUCCESS:
      return action.leaders;
    default:
      return state;
  }
}
